import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgMagnifyingGlass = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m25.12 23.88-5.477-5.474a9.637 9.637 0 1 0-1.237 1.237l5.475 5.476a.874.874 0 0 0 1.428-.954.874.874 0 0 0-.19-.284ZM4.374 12.25a7.875 7.875 0 1 1 7.875 7.875 7.883 7.883 0 0 1-7.875-7.875Z" />
  </svg>
);
export default SvgMagnifyingGlass;
